$(document).ready(function(){
  $('.customer-service-text').click(function() {
  //  window.location.href ="https://wa.me/5511917802808";
    window.open('https://wa.me/5511917802808', '_blank');
  });

$('button.button--primary').click(function() {
  $("button.button--primary").attr("aria-expanded","true");
});
  
  // $('.productView-moreItem:contains(Leia Mais...)').click(function(){
  //   window.open('/pages/politica-de-privacidade', '_blank');
  // });

  $('button.btn.button').click(function(){
    window.open('https://www.instagram.com/donaflamingo/', '_blank');
  });
  
   $('.productView-moreItem:contains(nossa News Letter)').click(function(){
    window.location.href ="#cadastrar-email";
  });
  
$("input.form-input-placeholder").attr("placeholder", "Buscar");

$("input#NewsletterForm--sections--18593517175060__footer-1").attr("placeholder", "informe seu melhor e-mail");

$('.spr-summary-actions-newreview').text('Escreva sua avaliação');
  
});